/* Edit or add personalization from the cart.
   Abbie, 2026-09-22: "in the cart - can we have the same option to customize next to the product?"

   "Edit personalization" / "Personalize it" (snippets/cart-item.liquid) open the product's own fields
   (sections/bbd-cart-pz.liquid, the same bbd-personalization-fields the product page uses) in a dialog,
   filled in from the cart line. Saving adds the product again with the new details and its extra-charge
   lines through BBP.cartLines — so the lines are built and ordered exactly as on the product page and
   Base Camp pairs them the same way — and only then removes the old line and its old add-ons. If the add
   fails (sold out, say), the old line stays put. */
(() => {
  if (window.BBDCartPz) return;
  window.BBDCartPz = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const style = document.createElement('style');
  style.textContent = `
    .bbd-ci-addon{display:flex;justify-content:space-between;gap:10px;margin-top:3px;color:#1D2D68;font-weight:600}
    .bbd-ci-pz{display:inline-block;margin:8px 0 2px;padding:5px 11px;border:1px solid #1D2D68;border-radius:999px;background:#fff;
      color:#1D2D68;font:inherit;font-size:12.5px;font-weight:600;line-height:1.3;cursor:pointer}
    .bbd-ci-pz:hover{background:#EEF1FA}
    .bbd-ci-pz:focus-visible{outline:3px solid #1D2D68;outline-offset:2px}
    dialog.bbd-cpz{width:min(560px,calc(100vw - 24px));max-height:calc(100vh - 32px);padding:0;border:0;border-radius:18px;
      box-shadow:0 20px 60px rgba(9,38,95,.28);color:#1D2D68;overflow:hidden}
    dialog.bbd-cpz::backdrop{background:rgba(9,38,95,.45)}
    .bbd-cpz__in{display:flex;flex-direction:column;max-height:calc(100vh - 32px);margin:0}
    .bbd-cpz__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:18px 20px 12px;border-bottom:1px solid #E6E9F2}
    .bbd-cpz__k{margin:0 0 2px;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#7C86A8}
    .bbd-cpz__t{margin:0;font-family:Georgia,serif;font-size:20px;line-height:1.25;color:#09265f}
    .bbd-cpz__x{flex:none;width:34px;height:34px;border:0;border-radius:50%;background:#F2F4F9;color:#1D2D68;font-size:20px;line-height:1;cursor:pointer}
    .bbd-cpz__body{flex:1;min-height:120px;overflow:auto;padding:4px 20px 8px}
    .bbd-cpz__body .bbp{margin-top:10px}
    .bbd-cpz__loading{padding:28px 0;text-align:center;color:#7C86A8}
    .bbd-cpz__err{margin:0 20px;padding:9px 12px;border-radius:10px;background:#FDECEE;color:#9B1C31;font-size:13.5px}
    .bbd-cpz__err[hidden]{display:none}
    .bbd-cpz__foot{display:flex;flex-wrap:wrap;gap:10px;align-items:center;justify-content:space-between;padding:14px 20px 18px;border-top:1px solid #E6E9F2}
    .bbd-cpz__extra{font-size:13px;color:#5F6782}
    .bbd-cpz__btns{display:flex;gap:8px;margin-left:auto}
    .bbd-cpz__cancel{padding:11px 16px;border:1px solid #D6DAE6;border-radius:10px;background:#fff;color:#1D2D68;font:inherit;font-weight:600;cursor:pointer}
    .bbd-cpz__save{padding:11px 20px;border:0;border-radius:10px;background:#1D2D68;color:#fff;font:inherit;font-weight:700;cursor:pointer}
    .bbd-cpz__save[disabled]{opacity:.6;cursor:progress}
  `;
  document.head.appendChild(style);

  let dlg, current = null;
  const el = (sel) => dlg.querySelector(sel);

  const build = () => {
    dlg = document.createElement('dialog');
    dlg.className = 'bbd-cpz';
    dlg.setAttribute('aria-labelledby', 'bbd-cpz-title');
    dlg.innerHTML = `
      <div class="bbd-cpz__in">
        <div class="bbd-cpz__head">
          <div><p class="bbd-cpz__k"></p><p class="bbd-cpz__t" id="bbd-cpz-title"></p></div>
          <button type="button" class="bbd-cpz__x" data-close aria-label="Close">×</button>
        </div>
        <div class="bbd-cpz__body" data-ps></div>
        <p class="bbd-cpz__err" role="alert" hidden></p>
        <div class="bbd-cpz__foot">
          <span class="bbd-cpz__extra" aria-live="polite"></span>
          <div class="bbd-cpz__btns">
            <button type="button" class="bbd-cpz__cancel" data-close>Cancel</button>
            <button type="button" class="bbd-cpz__save">Save</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]') || e.target === dlg) close();
    });
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    el('.bbd-cpz__save').addEventListener('click', save);
    // keep the running extra-charge total up to date
    dlg.addEventListener('bbp:change', showExtra);
  };

  const close = () => { const opener = current && current.opener; if (dlg && dlg.open) dlg.close(); current = null; if (opener && opener.isConnected) opener.focus(); };

  const money = (cents) => '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
  const showExtra = () => {
    if (!window.BBP || !current) return;
    const extra = BBP.extraPrice(el('.bbd-cpz__body'));
    el('.bbd-cpz__extra').textContent = extra > 0 ? 'Personalization: +' + money(extra * current.qty) + (current.qty > 1 ? ' (' + current.qty + ' × ' + money(extra) + ')' : '') : '';
  };

  const error = (msg) => { const e = el('.bbd-cpz__err'); e.textContent = msg || ''; e.hidden = !msg; };

  // Run the <script> tags that came back with the section (innerHTML leaves them inert).
  const runScripts = (node) => {
    node.querySelectorAll('script').forEach((old) => {
      const s = document.createElement('script');
      [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  };

  // Put the cart line's details back into the fields. Names repeat in some sets (Patch, Patch 2 …),
  // so number them the same way BBP.properties does.
  const fill = (scope, props) => {
    const seen = {};
    scope.querySelectorAll('[data-bbp-field]').forEach((f) => {
      if (f.dataset.type === 'Heading') return;
      const base = (f.dataset.name || f.dataset.label || 'Detail').trim();
      seen[base] = (seen[base] || 0) + 1;
      const v = props[seen[base] === 1 ? base : base + ' ' + seen[base]];
      if (v == null || v === '') return;
      const t = f.dataset.type;
      const touched = [];
      if (t === 'Dropdown') {
        const s = f.querySelector('select');
        const o = s && [...s.options].find((x) => x.value === v || x.value.trim().toLowerCase() === String(v).trim().toLowerCase());
        if (o) { s.value = o.value; touched.push(s); }
      } else if (t === 'Swatches' || t === 'Font tiles') {
        const r = [...f.querySelectorAll('input[type=radio]')].find((x) => x.value === v);
        if (r) { r.checked = true; touched.push(r); }
      } else if (t === 'Checkbox') {
        const boxes = [...f.querySelectorAll('input[type=checkbox]')];
        if (boxes.length === 1 && !boxes[0].closest('.bbp-checks').querySelector('[data-addon]') && boxes[0].id) boxes[0].checked = !!v;
        else { const picked = String(v).split(', '); boxes.forEach((b) => { b.checked = picked.includes(b.value); }); }
      } else if (t === 'Photo upload') {
        const h = f.querySelector('[data-bbp-input]'); if (h) h.value = v;
        const st = f.querySelector('[data-bbp-upload-status]'); if (st) st.textContent = '✓ Your photo is kept. Choose a new one to replace it.';
      } else {
        const i = f.querySelector('[data-bbp-input]'); if (i) { i.value = v; touched.push(i); }
      }
      touched.forEach((x) => x.dispatchEvent(new Event('change', { bubbles: true })));
    });
  };

  const settle = (scope) => {
    // show-if rules, chosen names and font samples all run off a change event inside [data-bbp]
    const any = scope.querySelector('[data-bbp] select, [data-bbp] input, [data-bbp] textarea');
    if (any) any.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const open = async (btn) => {
    if (!dlg) build();
    let props = {};
    try {
      // Liquid's `properties | json` gives [[name, value], …]; turn it into { name: value }
      const raw = JSON.parse(btn.dataset.props || '{}') || {};
      props = Array.isArray(raw) ? Object.fromEntries(raw.filter((p) => Array.isArray(p) && p.length === 2)) : raw;
    } catch (e) {}
    current = {
      opener: btn, key: btn.dataset.key, variant: Number(btn.dataset.variant), qty: Number(btn.dataset.qty) || 1,
      props, kids: (btn.dataset.kids || '').split(',').filter(Boolean),
      kidVariants: (btn.dataset.kidVariants || '').split(',').filter(Boolean).map(Number).sort()
    };
    const shown = Object.keys(props).filter((k) => k[0] !== '_' && props[k] !== '');
    el('.bbd-cpz__k').textContent = shown.length ? 'Edit personalization' : 'Personalize it';
    el('.bbd-cpz__t').textContent = btn.dataset.title || '';
    el('.bbd-cpz__extra').textContent = '';
    error('');
    const body = el('.bbd-cpz__body');
    body.innerHTML = '<p class="bbd-cpz__loading">Loading…</p>';
    el('.bbd-cpz__save').disabled = true;
    if (!dlg.open) dlg.showModal();
    try {
      const url = btn.dataset.url.split('?')[0];
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=bbd-cart-pz');
      if (!res.ok) throw new Error('load');
      body.innerHTML = await res.text();
      runScripts(body);
      if (!window.BBP || !body.querySelector('[data-bbp-field]')) throw new Error('fields');
      fill(body, props);
      settle(body);
      fill(body, props); // fields a show-if rule just revealed
      settle(body);
      showExtra();
      el('.bbd-cpz__save').disabled = false;
      const first = body.querySelector('[data-bbp-field]:not([hidden]) select, [data-bbp-field]:not([hidden]) input[type=text], [data-bbp-field]:not([hidden]) textarea');
      if (first) first.focus();
    } catch (e) {
      body.innerHTML = '<p class="bbd-cpz__loading">This one can\'t be changed from the cart. <a href="' + esc(btn.dataset.url) + '">Open the product page</a> to personalize it.</p>';
    }
  };

  const same = (a, b) => {
    const ka = Object.keys(a).sort(), kb = Object.keys(b).sort();
    return ka.length === kb.length && ka.every((k, i) => k === kb[i] && String(a[k]) === String(b[k]));
  };

  async function save() {
    if (!current || !window.BBP) return;
    const scope = el('.bbd-cpz__body');
    const missing = BBP.check(scope);
    if (missing.length) {
      error('Almost there: ' + missing.map((m) => (m.label || 'a detail').toLowerCase()).join(', ') + '.');
      if (missing[0].input) missing[0].input.focus();
      return;
    }
    error('');
    const oldShown = {};
    Object.keys(current.props).forEach((k) => { if (k[0] !== '_' && current.props[k] !== '') oldShown[k] = current.props[k]; });
    const newShown = BBP.properties(scope);
    const newKidVariants = BBP.addons(scope).map((a) => a.id).sort();
    if (same(oldShown, newShown) && newKidVariants.join() === current.kidVariants.join()) { close(); return; }

    // keep hidden details the product came with (e.g. _bunk_builder), but not the old add-on pairing
    const keep = {};
    Object.keys(current.props).forEach((k) => { if (k[0] === '_' && !/^_gpo/.test(k)) keep[k] = current.props[k]; });
    const lines = BBP.cartLines(scope, { id: current.variant, quantity: current.qty, properties: keep });

    const saveBtn = el('.bbd-cpz__save');
    saveBtn.disabled = true; saveBtn.textContent = 'Saving…';
    try {
      const add = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) });
      if (!add.ok) {
        let msg = 'That didn\'t save. Please try again.';
        try { const j = await add.json(); if (j && (j.description || j.message)) msg = j.description || j.message; } catch (e) {}
        throw new Error(msg);
      }
      const updates = {}; updates[current.key] = 0; current.kids.forEach((k) => { updates[k] = 0; });
      const rm = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      if (!rm.ok) throw new Error('Saved, but the old one is still in your cart. Please remove it.');
      close();
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    } catch (e) {
      error(e.message);
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    } finally {
      saveBtn.disabled = false; saveBtn.textContent = 'Save';
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-bbd-cart-pz]');
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });
})();

// The custom product pages (standard, trunk, bedding, bundle, complete-the-look) stay on
// the page after Add to cart and announce it with "cart:updated". The cart drawer only
// refreshes on "on:cart:change", so it kept the empty copy it loaded with the page and
// said "Your bag is empty". Bridge the two. (2026-10-04)
document.addEventListener('cart:updated', () => {
  document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
});
